var render = function render(){var _vm=this,_c=_vm._self._c;return _c('phototype-template',{attrs:{"skin-type":_vm.skinType,"skin-color":_vm.skinColor,"field-errors":_vm.fieldErrors},on:{"field-change":_vm.onFieldChange}})
}
var staticRenderFns = []

export { render, staticRenderFns }